import { render, staticRenderFns } from "./ot-form-modal.vue?vue&type=template&id=759366da&scoped=true&"
import script from "./ot-form-modal.vue?vue&type=script&lang=ts&"
export * from "./ot-form-modal.vue?vue&type=script&lang=ts&"
import style0 from "./ot-form-modal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ot-form-modal.vue?vue&type=style&index=1&id=759366da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759366da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VDivider,VIcon})
